// extracted by mini-css-extract-plugin
export default {"submitButtonSpacing":"submitButtonSpacing__1aWql","inputSpacing":"inputSpacing__2y8Uq","container":"container__32r9s","title":"title__1MFRL"};